import { BlockComponentModel } from '@/components/cms/types/blok-component';
import { SECTION_NAMES } from '@/components/integrations/trackingScripts/constants';
import { Quote } from '@/decodo/components/atoms/Quote';
import RichTextFieldStrapi, {
  RichTextFieldStrapiProps,
} from '@/decodo/components/atoms/RichTextField/RichTextFieldStrapi';

import { BlockHeaderContent } from '@/features/utils/BlockHeaderContentDC';
import { BlockWrapper } from '@/features/utils/BlockWrapperDC';

export type QuoteProps = {
  text: RichTextFieldStrapiProps;
};

export function QuoteStrapi({
  block,
  ...rest
}: BlockComponentModel<QuoteProps>) {
  const { text } = block;

  return (
    <BlockWrapper {...rest} data-tracker-section={SECTION_NAMES.QUOTE}>
      <div data-tracker-component='quote'>
        <BlockHeaderContent>
          <Quote>
            <div className='text-left'>
              <RichTextFieldStrapi block={text} />
            </div>
          </Quote>
        </BlockHeaderContent>
      </div>
    </BlockWrapper>
  );
}
